import ModalEventController from "./modal_event_controller"

export default class extends ModalEventController {

}